import type { FC } from "react";
import { useState } from "react";

import Edit from "@/assets/icons/edit";
import AdministrativeInfosUpdateModal from "@/components/modals/administrative-infos-update-modal";
import type { PatientProps } from "@/components/patient/patient-profile";
import PatientProfilePart from "@/components/patient/patient-profile-part";
import { Button } from "@/components/ui/button";
import { formatPhoneNumber } from "@/utils/patient";

const PatientAdministrativeInfos: FC<PatientProps> = ({ patient }) => {
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

  const hasAddress = patient.address || patient.addressComplement;
  const hasCity = patient.postalCode || patient.city;
  const address = `${patient.address ? patient.address + ", " : ""}${patient.addressComplement ?? ""}`;
  const city = `${patient.postalCode ? patient.postalCode + " " : ""}${patient.city ?? ""}`;

  return (
    <PatientProfilePart title={"Informations administratives"}>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="text-xs text-gray-500">Date de naissance</div>
          <div className="text-sm">
            {new Date(patient.birthDate).toLocaleDateString()}
          </div>
        </div>
        <div>
          <div className="text-xs text-gray-500">Adresse email</div>
          <div className="text-sm">{patient.email}</div>
        </div>
        {patient.homePhone ? (
          <div>
            <div className="text-xs text-gray-500">Téléphone fixe</div>
            <div className="text-sm">
              {formatPhoneNumber(patient.homePhone)}
            </div>
          </div>
        ) : null}
        {patient.mobilePhone ? (
          <div>
            <div className="text-xs text-gray-500">Téléphone portable</div>
            <div className="text-sm">
              {formatPhoneNumber(patient.mobilePhone)}
            </div>
          </div>
        ) : null}
        {patient.job ? (
          <div>
            <div className="text-xs text-gray-500">Profession</div>
            <div className="text-sm">{patient.job}</div>
          </div>
        ) : null}
        {hasAddress || hasCity ? (
          <div>
            <div className="text-xs text-gray-500">Adresse postale</div>
            {hasAddress ? <div className="text-sm">{address}</div> : null}
            {hasCity ? <div className="text-sm">{city}</div> : null}
          </div>
        ) : null}
      </div>
      <div className="flex justify-end">
        <Button
          type="button"
          variant="text"
          className="text-brand-800 gap-[2px] justify-end"
          onClick={() => setIsUpdateModalOpen(true)}
        >
          <Edit color="#8470FF" className="w-5 h-5" />
          <div className="font-semibold px-[2px]">Modifier</div>
        </Button>
      </div>
      <AdministrativeInfosUpdateModal
        open={isUpdateModalOpen}
        setOpen={setIsUpdateModalOpen}
        patient={patient}
      />
    </PatientProfilePart>
  );
};

export default PatientAdministrativeInfos;
